module.exports = __webpack_public_path__ + "img/slide1.bcd20695.png";